import { Component, OnInit } from '@angular/core';
import { GeneralLedgerService } from '../../../../services/general-ledger.service';
import { Store } from '@ngxs/store';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import { mergeMap } from 'rxjs/operators';
import { Pagination } from '../../../../models/pagination';
import {
  GeneralLedgerExportTypes,
  GLConfigCategory,
  GLConfiguration,
  GlExportHistory
} from '../../../../models/general-ledger';
import { GetTimeInEST } from '../../../../utils/dateUtils';
import {
  GlSelectedConfigChanged,
  GlTabChanged
} from '../../../../state/GeneralLedgerState/GeneralLedger.state';

@Component({
  selector: 'lib-gl-export-history-tab',
  templateUrl: './gl-export-history-tab.component.html',
  styleUrls: ['./gl-export-history-tab.component.css'],
  standalone: false
})
export class GlExportHistoryTabComponent implements OnInit {
  pagination: Pagination;
  items: GlExportHistory[];
  errorsToShow: string[];
  constructor(
    private glService: GeneralLedgerService,
    private store: Store
  ) {}
  ngOnInit() {
    this.loadPage();
  }
  navigateToConfig(config: GlExportHistory) {
    this.store.dispatch(new GlSelectedConfigChanged(config.ConfigId)).subscribe(_ => {
      this.store.dispatch(new GlTabChanged(1));
    });
  }
  pageChanged(pagination: Pagination) {
    this.loadPage(pagination.Page);
  }

  private loadPage(pageNum: number = 1) {
    this.store
      .selectOnce(ClientSelectionState.clientCode)
      .pipe(
        mergeMap(code => {
          return this.glService.getGlExportHistory(code, pageNum, 10);
        })
      )
      .subscribe(result => {
        this.pagination = result.Pagination;
        this.errorsToShow = [];
        this.items = result.Items.map(item => {
          let originalDate = item.Created;
          if (typeof originalDate == 'string') {
            originalDate = new Date(originalDate);
          }
          item.Created = GetTimeInEST(
            originalDate.getHours(),
            originalDate.getMinutes(),
            originalDate
          );
          if (
            item.Error != null &&
            item.Error != '' &&
            this.errorsToShow.length < 1 &&
            item.Status == 'failure'
          ) {
            this.errorsToShow.push(`${item.ConfigName} export failed.`);
          }
          return item;
        });
      });
  }

  protected readonly GeneralLedgerExportTypes = GeneralLedgerExportTypes;
}
